// extracted by mini-css-extract-plugin
export default {"button":"ToggleLocationFavourite_button__U6l0f"};